const wowApp = require('angular').module('wowApp.shop');
wowApp.filter('fromNow', function () {
  return function (datestring) {
    var date = new Date(datestring);
    var now = new Date();
    var diffInSeconds = Math.floor((now - date) / 1000);
    // Calculate time difference in different units
    var minutes = Math.floor(diffInSeconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var weeks = Math.floor(days / 7);
    var months = Math.floor(days / 30);
    var years = Math.floor(days / 365);
    // Return a human-readable string based on the time difference
    if (diffInSeconds < 60) {
      return diffInSeconds + ' seconds ago';
    } else if (minutes < 60) {
      return minutes + ' minute' + (minutes > 1 ? 's' : '') + ' ago';
    } else if (hours < 24) {
      return hours + ' hour' + (hours > 1 ? 's' : '') + ' ago';
    } else if (days < 7) {
      return days + ' day' + (days > 1 ? 's' : '') + ' ago';
    } else if (weeks < 4) {
      return weeks + ' week' + (weeks > 1 ? 's' : '') + ' ago';
    } else if (months < 12 || months == 12) {
           if (months == 12 && days < 365){
            return '11' + ' month' + (months > 1 ? 's' : '') + ' ago';
           }
           else{
            return months + ' month' + (months > 1 ? 's' : '') + ' ago';
           }
    } else {
      return years + ' year' + (years > 1 ? 's' : '') + ' ago';
    }
  };
});
wowApp.directive('helpCenter', ['HelpCenterService', '$sce', 'BwsBotService', require('./help-center-directive.js')]);
wowApp.service('HelpCenterService', ['ProxyService', '$http', require('./help-center-service')]);
wowApp.directive('sectionsArticles', ['HelpCenterService', require('./sections-articles-directive.js')]);
wowApp.directive('zendeskArticle', ['HelpCenterService', '$sce','AtmService', require('./zendesk-article-directive.js')]);
wowApp.directive('searchResult', ['HelpCenterService', '$sce', require('./search-result-directive.js')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/index.js
 **/